// TODO - delete in favor of using v2

/* eslint-disable */
import React, { useEffect, useState } from "react";

// COMPONENTS
import CheckInTagGroup from "../display/CheckInTagGroup";

// MODULES
import { useResizeDetector } from "react-resize-detector";

// STYLES
import "./IHRCheckInReportGraphSegment.scss";
import StaticForwardingPPGWaveformLineChart2 from "../charts/StaticForwardingPPGWaveformChart2";
import { useParams } from "react-router-dom";

// ICONS
import { TagsIcon, NotesIcon } from "../iconify/icons";
import useBrowserClass from "../../../hooks/environment/useBrowserClass";
import StaticScrollingPPGWaveformChart from "../charts/ScrollablePPGWaveform";

interface IIHRCheckInReportGraphSegmentProps {
    className?: string;
    start: string;
    bpm: number;
    ppgWaveform: number[];
    inPrintMode: boolean;
    containerWidthOverride: null | number;
    tags: string[] | undefined | null;
    notes: string | undefined | null;
    [key: string]: any;
}

const IHRCheckInReportGraphSegment: React.FC<
    IIHRCheckInReportGraphSegmentProps
> = ({
    className = "",
    start,
    bpm,
    ppgWaveform,
    inPrintMode,
    containerWidthOverride,
    tags = [],
    notes = "",
    ...rest
}) => {
    // Lets be type safe with this - don't remove the typing even though I'm pretty sure this should be handled by the error element
    const { reportId }: { [paramName: string]: string | undefined } =
        useParams();
    const { width, ref } = useResizeDetector();

    const [widthOverride, setWidthOverride] = useState<null | number>(
        width ?? 0,
    );
    //const [inPrintMode, setInPrintMode] = useState(false);

    const [reflexiveChartMinorTicks, setReflexiveChartMinorTicks] =
        useState<number>(3);
    const [
        reflexiveChartMajorTickDistance,
        setReflexiveChartMajorTickDistance,
    ] = useState<number>(50);

    const browserClass = useBrowserClass();

    useEffect(() => {
        if (containerWidthOverride !== null) {
            setWidthOverride(containerWidthOverride);
        } else {
            setWidthOverride(width ?? 0);
        }
    }, [containerWidthOverride, width]);

    // useEffect(() => {
    //     const handleBeforePrint = () => {
    //         console.log("BEFOREPRINT triggered");
    //         if (width && width >= 700) {
    //             if (browserClass === "browser-chrome") {
    //                 setContainerWidthOverride(900);
    //             }
    //             if (browserClass === "browser-safari") {
    //                 setContainerWidthOverride(700);
    //             }
    //             if (browserClass === "browser-firefox") {
    //                 setContainerWidthOverride(700);
    //             }

    //             setTimeout(() => {
    //                 window.dispatchEvent(new Event("resize"));
    //             }, 0);
    //         }
    //     };

    //     const handleAfterPrint = () => {
    //         console.log("AFTERPRINT triggered");
    //         setContainerWidthOverride(null);
    //     };

    //     window.addEventListener("beforeprint", handleBeforePrint);
    //     window.addEventListener("afterprint", handleAfterPrint);

    //     return () => {
    //         window.removeEventListener("beforeprint", handleBeforePrint);
    //         window.removeEventListener("afterprint", handleAfterPrint);
    //     };
    // }, [width, browserClass]);

    // useEffect(() => {
    //     const mediaQueryList = window.matchMedia("print");

    //     const listener = (e: MediaQueryListEvent) => {
    //         if (e.matches) {
    //             console.log("Entering print mode");
    //             setInPrintMode(true);
    //             if (width && width >= 700) {
    //                 if (browserClass === "browser-chrome") {
    //                     console.log("chrome detected");
    //                     setContainerWidthOverride(900);
    //                 }
    //                 if (browserClass === "browser-safari") {
    //                     setContainerWidthOverride(700);
    //                 }
    //                 if (browserClass === "browser-firefox") {
    //                     console.log("ff detected");
    //                     setContainerWidthOverride(700);
    //                 }
    //             }
    //         } else {
    //             console.log("Exiting print mode");
    //             setInPrintMode(false);
    //             setContainerWidthOverride(null);
    //         }
    //     };

    //     mediaQueryList.addEventListener("change", listener);

    //     return () => {
    //         mediaQueryList.removeEventListener("change", listener);
    //     };
    // }, [width]);

    return (
        <div className={`IHRCheckInReportGraphSegment ${className}`} {...rest}>
            <div className="reportWrapper">
                {/* BPM */}
                <div className="reportMetadataGrid no-margin">
                    <div></div>
                    <h3>{bpm} bpm</h3>
                </div>
                {/* DATE */}
                <div className="reportMetadataGrid no-margin">
                    <div></div>
                    <p>{start}</p>
                </div>
                {/* Graph */}
                <div className="waveformWrapper">
                    <div ref={ref} className="PPGWaveformResizeRefContainer">
                        {inPrintMode ? (
                            <StaticForwardingPPGWaveformLineChart2
                                data={ppgWaveform}
                                pixelsPerSecond={
                                    reflexiveChartMajorTickDistance
                                }
                                verticalGridLines={reflexiveChartMinorTicks}
                                lineStrokeWidth={2}
                                containerWidth={
                                    //width ?? 0
                                    // containerWidthOverride == null
                                    //     ? width ?? 0
                                    //     : containerWidthOverride
                                    widthOverride ?? 0
                                }
                                inPrintMode={inPrintMode}
                            />
                        ) : (
                            <StaticScrollingPPGWaveformChart
                                data={ppgWaveform}
                                pixelsPerSecond={
                                    reflexiveChartMajorTickDistance
                                }
                                verticalGridLines={reflexiveChartMinorTicks}
                                lineStrokeWidth={2}
                            />
                        )}
                        {/* <StaticForwardingPPGWaveformLineChart2
                            data={ppgWaveform}
                            pixelsPerSecond={reflexiveChartMajorTickDistance}
                            verticalGridLines={reflexiveChartMinorTicks}
                            lineStrokeWidth={2}
                            containerWidth={
                                //width ?? 0
                                // containerWidthOverride == null
                                //     ? width ?? 0
                                //     : containerWidthOverride
                                widthOverride ?? 0
                            }
                            inPrintMode={inPrintMode}
                        /> */}
                        {/* <StaticScrollingPPGWaveformChart
                            data={ppgWaveform}
                            pixelsPerSecond={reflexiveChartMajorTickDistance}
                            verticalGridLines={reflexiveChartMinorTicks}
                            lineStrokeWidth={2}
                        /> */}
                    </div>
                </div>
                {/* Tags */}
                <div className="reportMetadataGrid">
                    <div className="reportIcon">{TagsIcon}</div>
                    <div className="tagsWrapper">
                        {tags ? (
                            <CheckInTagGroup tags={tags} />
                        ) : (
                            "todo - no tags"
                        )}
                    </div>
                </div>
                {/* Notes */}
                <div className="reportMetadataGrid">
                    <div className="reportIcon">{NotesIcon}</div>
                    <div className="notesText">{notes}</div>
                </div>
            </div>
        </div>
    );
};

export default IHRCheckInReportGraphSegment;

// useEffect(() => {
//     if (!!width) {
//         if (width >= 1200) {
//             setReflexiveChartMajorTickDistance(25);
//             setReflexiveChartMinorTicks(5);
//         } else if (width > 1000) {
//             setReflexiveChartMajorTickDistance(40);
//             setReflexiveChartMinorTicks(3);
//         } else {
//             setReflexiveChartMajorTickDistance(50);
//             setReflexiveChartMinorTicks(3);
//         }
//     }
// }, [width]);

// useEffect(() => {
//     if (!!width) {
//         console.log("WIDTH OF GRAPH CONTAINER", width);
//     }
// }, [width]);
